module.exports = __webpack_public_path__ + "static/22-d0c5bf2ad33dd821072db85c2cfc94d6.jpg";